import { ca } from '@cian/analytics';

import { ANALYTICS_OBJECT_TYPES } from '../../utils/analytics';

export function trackPriceOpened(objectType: string, villageId: number) {
  ca('event', {
    action: 'goto_listing_price',
    category: 'Listing_KP',
    label: ANALYTICS_OBJECT_TYPES[objectType],
    name: 'oldevent',
    oid: villageId,
  });
}
